import { Controller } from "stimulus";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

export default class extends Controller {
  static get targets() {
    return ["select", "hiddenDiv"];
  }

  connect() {
    if (!this.preventInitialCheck) {
      this.checkVisibility();
    }
  }

  checkVisibility() {
    this.hiddenDivTargets.forEach((target) => {
      // Each target defines which value triggers it via data-show-on
      const isVisible = this.selectTarget.value === target.dataset.showOn;

      if (isVisible) {
        showElement(target);

        this.hiddenInputs(target).forEach(enableElement);
      } else {
        hideElement(target);

        this.hiddenInputs(target).forEach(disableElement);
      }
    });
  }

  hiddenInputs(container) {
    return [
      ...container.querySelectorAll("input"),
      ...container.querySelectorAll("select"),
      ...container.querySelectorAll("textarea")
    ];
  }

  get preventInitialCheck() {
    return this.element.dataset.preventInitialCheck === "true";
  }
}
